import React from 'react';
import EntityGridToolbar from 'containers/Grid/components/EntityGridToolbar';

const SecurityPatchHistoryToolbar = (props) => {
    const {
        refreshGrid,
          } = props;

    return (
        <EntityGridToolbar
            onRefresh={refreshGrid}
            showRefreshButton={true}
            showSearch={false}
        />
    );
};

SecurityPatchHistoryToolbar.propTypes = {};

export default SecurityPatchHistoryToolbar;